import { ArrowUpRight } from 'lucide-react'
import { useState } from 'react'
import { cn } from '../utils/cn'

export default function CardServicos({
  title,
  text,
  icon,
  glowColor,
  url,
  textSize,
  width,
  height,
  saberMais,
  className = '',
}) {
  const [isHovered, setIsHovered] = useState(false)

  function handleMouseEnter() {
    setIsHovered(true)
  }

  function handleMouseLeave() {
    setIsHovered(false)
  }

  const CardContent = () => (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onTouchStart={handleMouseEnter}
      onTouchEnd={handleMouseLeave}
      className={cn(
        'relative hover:cursor-pointer',
        height ? `h-[${height}px]` : 'h-[350px]',
        width ? `w-[${width}px]` : 'w-[350px]',
        className,
      )}
    >
      <div
        className={`absolute inset-0 transition-opacity duration-300 blur-xl ${
          isHovered ? 'opacity-80' : 'opacity-0'
        }`}
        style={{ backgroundColor: glowColor }}
      />
      <div className="relative z-10 rounded-lg py-6 px-8 bg-[#1B182D] text-white h-full w-full flex flex-col">
        <div className="relative w-fit min-w-[52px] aspect-square">
          <div
            className={`absolute inset-0 rounded-full aspect-square transition-all duration-300 ${
              isHovered
                ? 'bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] opacity-100'
                : 'bg-white/10 blur-[2px]'
            }`}
          />
          <div className="absolute inset-[2px] aspect-square rounded-full bg-[#1B182D] flex items-center justify-center">
            <img className="size-7 object-contain" src={icon} alt={title} />
          </div>
        </div>
        <h1
          className={`mt-6 font-inter-bold ${
            textSize === 'small' ? 'text-[20px]' : 'text-2xl'
          }`}
        >
          {title}
        </h1>
        <p
          className={`mt-6 font-inter-regular ${
            textSize === 'small' ? 'text-sm' : 'text-base'
          }`}
        >
          {text}
        </p>

        {/* Botão que muda para branco no hover - posicionado na parte inferior */}
        {saberMais && (
          <div className="mt-auto pt-6">
            {isHovered ? (
              <div className="inline-block px-9 py-1 rounded-full hover:scale-105 transition-all duration-300 hover:cursor-pointer bg-white flex flex-row">
                <div className="font-poppins-light text-sm text-[#110940] flex items-center">
                  Saber mais
                  <ArrowUpRight
                    className="ml-2 inline"
                    width={20}
                    height={20}
                  />
                </div>
              </div>
            ) : (
              <p className="font-poppins-light text-sm text-white flex flex-row items-center">
                Saber mais
                <ArrowUpRight className="ml-2" width={20} height={20} />
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  )

  return url ? (
    <a href={url} className="block no-underline text-inherit">
      <CardContent />
    </a>
  ) : (
    <CardContent />
  )
}
